// Signature for the name of the money:
export const CURRENCY: string = 'DEMO'

// Modals animation:
export const ANIMATION_BEZIER: string = 'cubic-bezier(.64,-0.1,.22,1.72)'

// for chips in stacks:
export const SCATTER_OF_POSITION_OF_CHIPS_ON_BOARD: number = 7
export const SCATTER_OF_ROTATION_OF_CHIPS_ON_BOARD: number = 90
export const DISTANCE_BETWEEN_CHIPS_IN_STACK: number = 5

// errors:
export const NOT_ENOUGH_MONEY_ERROR: string = 'Not enough money on your balance !'

// blocks titles:
export const TITLE_COEFFICIENTS: string = 'Coefficients'
export const TITLE_HISTORY: string = 'Results history'
export const EMPTY_HISTORY_TEXT: string = 'No spins yet'

// Modals text:
export const NO_AWARD_TEXT: string = 'You lose'
export const WIN_TEXT: string = 'You win: '